import type { Identity } from '../types';
import { getAvatarTotalHeight } from '../components/identified-responses/utils';

interface GetScoreYAdjustmentProps {
  currentScore: number;
  identityList: Identity[] | undefined;
  hasImage: boolean;
  barWidth: number;
  barHeight: number;
}

export const getScoreYAdjustment = ({
  currentScore,
  identityList,
  hasImage,
  barWidth,
  barHeight,
}: GetScoreYAdjustmentProps) => {
  // currently the results and identified results are fetched separately and they can be different (e.g hidden results, identified results cap)
  if (currentScore === 0) {
    return 0;
  }

  const hasIdentityAvatars = Boolean(
    identityList?.length && identityList?.length > 0,
  );

  const avatarTotalHeight = getAvatarTotalHeight(barWidth);
  const avatarAndRectangleHeightDiff = avatarTotalHeight - barHeight;

  const shouldAdjustScorePosition =
    hasIdentityAvatars && !hasImage && avatarAndRectangleHeightDiff > 0;

  if (shouldAdjustScorePosition) {
    return avatarAndRectangleHeightDiff;
  }

  return 0;
};
